import type { User } from 'shared/store/auth'

export interface AccountIdentity {
	label: string
	copyValue: string | null
}

export function getAccountIdentity({
	username,
	name,
	telegramId,
}: Pick<User, 'username' | 'name' | 'telegramId'>): AccountIdentity {
	const trimmedUsername = username?.trim() ?? ''
	if (trimmedUsername) {
		return { label: `@${trimmedUsername}`, copyValue: trimmedUsername }
	}

	const trimmedName = name.trim()
	const id = telegramId === undefined ? null : String(telegramId)
	return { label: trimmedName || id || '', copyValue: id }
}
